import {CountryKeys} from 'shared/lib'

export enum PaymentProviderType {
  COREFY = 'corefy',
  MAXPAY = 'maxpay-hpp',
  COIN_PAYMENTS = 'coin-payments',
  NODA = 'noda'
}

export enum PaymentMethodType {
  CARD = 'card',
  TOKEN = 'token',
  SEPA = 'sepa',
  PAYPAL = 'paypal',
  GOOGLE_PAY = 'google-pay',
  APPLE_PAY = 'apple-pay',
  CRYPTO = 'crypto'
}

export enum CardBrands {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  JCB = 'jcb',
  AMERICAN_EXPRESS = 'american-express',
  DINERS_CLUB = 'diners-club',
  DISCOVER = 'discover',
  ELO = 'elo',
  HIPERCARD = 'hipercard',
  HIPER = 'hiper',
  MAESTRO = 'maestro',
  MIR = 'mir',
  UNIONPAY = 'unionpay'
}

export type PackageType = {
  id: number,
  name: string,
  credits: number,
  stickers: number,
  photos: number,
  videos: number,
  virtualGifts: number,
  price: number,
  originPrice: number
}

export enum PaymentStatus {
  IN_PROGRESS,
  SUCCESS,
  FAILED,
  SEPA_IN_PROGRESS
}

export type PaymentSuccessResponse = {
  idOrder: string
  package: {
    id: number,
    name: string,
    price: number,
    originPrice: number,
    credits: number,
    stickers: number,
    photos: number,
    videos: number,
    virtualGifts: number
  }
}

export type PaymentFailedResponse = PaymentSuccessResponse & {reason: string}

export type TokenType = {
  id: string,
  brand: CardBrands,
  card: string,
  expireMonth: string,
  expireYear: string,
  provider: PaymentProviderType
}

export type SepaProviderType = {
  id: string
  name: string
  logoUrl: string
}

export type SepaContextType = {
  options: SepaProviderType[]
}

export type MaxPayContextType = {
  key: string
  name: string
  uniqueuserid: string
  type: string
  height: string
  width: string
  uniqueTransactionId: string
  email: string
  success_url: string
  decline_url: string
  iframesrc: string
  buttontext: string
  customproduct: Record<string, string>[]
  country: CountryKeys
  city: string
  zip: string
  signature: string
}

export type CryptoOptions = {
  id: string
  name: string
  logoUrl: string
  price: number
}

export type ApplePayContextType = {
  merchant: {
    id: string
    countryCode: string,
    currencyCode: string,
    supportedNetworks: string[],
    merchantCapabilities: string[],
    total: ApplePayJS.ApplePayLineItem
  }
}

export type CorefyCardContextType = {
  success: boolean
  threeDs: {
    action: string
    method: 'post' | 'put'
    params: object
  } | null
}